import { DateTime } from 'luxon';
import type { FieldValues, Path, RegisterOptions } from 'react-hook-form';

import type { useTranslations } from '~i18n/hooks';

export const validateDoB = (
	date: Date,
	t: ReturnType<typeof useTranslations>
) => {
	const now = DateTime.now();
	const parsed = DateTime.fromJSDate(date);

	if (!parsed.isValid || parsed.year <= 1900) {
		return t('validationDateInvalid');
	}
	if (now.minus({ year: 18 }).startOf('day') <= parsed.startOf('day')) {
		return t('validationDateUnderage');
	}
	return true;
};

const EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const validateEmailByRegexp = (
	value: string,
	t: ReturnType<typeof useTranslations>
) => {
	if (!EMAIL.test(value)) {
		return t('validationEmailInvalid');
	}

	return true;
};

export const validateEmailPreset = <
	TFieldValues extends FieldValues,
	TFieldName extends Path<TFieldValues>
>(
	t: ReturnType<typeof useTranslations>
): RegisterOptions<TFieldValues, TFieldName> => ({
	required: t('validationRequired'),
	maxLength: { value: 254, message: t('validationEmailMaxLength') },
	validate: (v) => validateEmailByRegexp(v, t),
});

export const validatePassByRegexp = (
	value: string,
	t: ReturnType<typeof useTranslations>
) => {
	if (!/^[~`!@#$%^&*()_+=[\]\\{}|;':",.\/<>?a-zA-Z0-9-]+$/.test(value)) {
		return t('validationPasswordInvalid');
	}

	return true;
};

export const validatePasswordPreset = <
	TFieldValues extends FieldValues,
	TFieldName extends Path<TFieldValues>
>(
	t: ReturnType<typeof useTranslations>
): RegisterOptions<TFieldValues, TFieldName> => ({
	required: t('validationPasswordRequired'),
	minLength: { value: 6, message: t('validationPasswordMinLength') },
	maxLength: { value: 32, message: t('validationPasswordMaxLength') },
	validate: (v) => validatePassByRegexp(v, t),
});
